export default() => ({
	is_active: false,
	init() {
		this.is_active = this.isActive();
	},
	isActive() {
		const rect = this.$root.getBoundingClientRect();
		return (
			rect.left >= 0 &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	},
	scroll() {
		this.is_active = this.isActive();
	},
	track_begin_end_state: {
		'x-intersect:enter.threshold.05'() {
			const $slides = this.$el.parentElement.children;

			if ( $slides[0] === this.$el ) {
				this.at_beginning = true;
			} else if ( $slides[$slides.length - 1] === this.$el ) {
				this.at_end = true;
			}
		},
		'x-intersect:leave.threshold.05'() {
			const $slides = this.$el.parentElement.children;

			if ( $slides[0] === this.$el ) {
				this.at_beginning = false;
			} else if ( $slides[$slides.length - 1] === this.$el ) {
				this.at_end = false;
			}
		}
	}
});
